import gql from 'graphql-tag';

export const updateUserMfaEnrollmentStatus = gql`
  mutation updateUserMfaEnrollmentStatus($input: UpdateUserMfaEnrollmentStatusInput!) {
    updateUserMfaEnrollmentStatus(input: $input) {
      id
      preferences {
        mfaEnrollmentStatus
      }
    }
  }
`;
